import {
  Table,
  TableBody,
  TableBodyRow,
  TableCell,
  TableContainer,
  TableHeaderCell,
  TableHeaderRow,
} from './components';
import { Arrangement } from 'types/arrangement';
import { CreditType } from 'types/credit';
import RequiredCredentialsSectionSmall from '../RequiredCredentialsSectionSmall';
import SubjectsSection from '../SubjectsSectionSmall';
import { getTotalCreditPoints } from 'utils/arrangement';
import useTranslation from 'hooks/use-translation';

export type Props = {
  arrangements: Arrangement[];
};

export default function ArrangementDetailsCard(props: Props): JSX.Element {
  const { arrangements } = props;
  const translation = useTranslation();
  return (
    <TableContainer>
      <Table>
        <TableHeaderRow className='credit-items-header'>
          <TableHeaderCell>{translation?.arrangements.completedSubjects}</TableHeaderCell>
          <TableHeaderCell>{translation?.arrangements.targetSubjects}</TableHeaderCell>
          <TableHeaderCell>{translation?.arrangements.creditPoints}</TableHeaderCell>
        </TableHeaderRow>
        <TableBody>
          {arrangements.map((arrangement) => (
            <TableBodyRow key={arrangement.ID}>
              <TableCell className='required-credentials-section'>
                <RequiredCredentialsSectionSmall requiredCredentials={arrangement.requiredCredentials} />
              </TableCell>
              <TableCell>
                <SubjectsSection arrangement={arrangement} creditType={CreditType.ARTICULATION} />
              </TableCell>
              <TableCell textAlign='right'>{getTotalCreditPoints(arrangement)}</TableCell>
            </TableBodyRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
